import { HttpHeaders } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';

import { PaymentsCashierConfig } from '../client-config/client-config.models';
import { CustomHttpClientService } from '../http/custom-http-client.service';

@Injectable({
    providedIn: 'root',
})
export class PaymentsAuthenticationService {
    constructor(
        protected customHttpClientService: CustomHttpClientService,
        protected injector: Injector,
    ) {}

    authenticateUser(sessionInfo: { [key: string]: string }, url: string) {
        const host = this.injector.get(PaymentsCashierConfig).host;
        const requestData = {
            userId: sessionInfo['userId'],
            labelInfo: {
                brandId: sessionInfo['brandId'],
                productId: sessionInfo['productId'],
                channelId: sessionInfo['channelId'],
            },
        };

        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                // TODO: Remove once the cashier backend starts reading SSO from cookies
                'sso-key': sessionInfo['sessionKey'] || '',
            }),
            observe: 'response' as 'body',
            withCredentials: true,
        };

        return this.customHttpClientService.httpClient.post(host + url, requestData, httpOptions);
    }
}
